import CardMenu from "./card-menu";

export default CardMenu;